import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { trackFeatureUsageRequested } from 'features/feature-set/actions';

export function* trackFeatureUsageSaga(action: ReturnType<typeof trackFeatureUsageRequested>) {
  yield call(SignalingSocket.send, {
    event: 'trackUsage',
    data: { feature: action.payload },
  });
}
